<template>
<div class="containers">
    <div class="search-area">
        <CRow class="no-gutters">
            <CCol sm="5" style="padding-right:12px">
                <input type="text" v-model="searchKode" placeholder="Kode Shift" class="inputs-form form-control"/>
            </CCol>
            <CCol sm="5" style="padding-right:12px">
                <input type="text" v-model="searchDeskripsi" placeholder="Deskripsi" class="inputs-form form-control"/>
            </CCol>
            <CCol sm="2" style="padding-left:4px">
                <CButton style="float:right" @click="findData()" type="button" class="btn btn-search">Cari</CButton>
            </CCol>
        </CRow>
    </div>
    <div class="sticky1">
        <CRow>
            <CCol sm="6"></CCol>
            <CCol sm="6">
                <span style="float:right">
                    <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                    <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                    <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                </span>
                <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                <img class="mr-5 mt-1" style="float:right" :src="moreIcon" width="20px" height="20px"/>
                <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="cursor:pointer;float:right"/>
            </CCol>
        </CRow>
    </div>
    <Tables :data="datas" :td="dataTd" :thAdd="false" :styleTable="styleTable" :errors="errorMessage"></Tables>
</div>
</template>

<script>
import Tables from '../../../component/tableShift'
import {DataApi} from "../../../service/DataApi";
import { ModelSelect } from 'vue-search-select'
export default {
    components: {
        ModelSelect,
        Tables
    },
    data() {
        return {
            // datas
            refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
            moreIcon: require('../../../assets/menu/icon_more.svg'),
            dataTd: [
                'kode',
                'deskripsi',
                'shift1Masuk',
                'shift1Keluar',
                'shift1Hari',
                'shift2Masuk',
                'shift2Keluar',
                'shift2Hari',
                'shift3Masuk',
                'shift3Keluar',
                'shift3Hari',
                'shift4Masuk',
                'shift4Keluar',
                'shift4Hari',
            ],
            styleTable: ['50px', '100px', '40px', '40px', '40px', '40px', '40px', '40px', '40px', '40px', '40px', '40px', '40px', '40px'],
            classReload: 'reloadOff',
            datas: [],

            // paging
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            // filter
            searchKode: '',
            searchDeskripsi: '',

            // error
            errorMessage: '',
            flagSearch: false
        }
    },
    watch: {
        page() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        searchKode() {
            this.flagSearch = true
        },
        searchDeskripsi() {
            this.flagSearch = true
        },
    },
    methods: {
        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            let limit = this.size
            let kodeShift = this.searchKode
            let deskripsi = this.searchDeskripsi
            let page = this.page

            let payload = {
                limit: limit,
                kodeShift: kodeShift,
                deskripsi: deskripsi,
                pageIn: page,
            }
            DataApi.post("shift/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        findData() {
            this.getData()
        },
        reload() {
            this.searchKode = ''
            this.searchDeskripsi = ''
            this.flagSearch = true
            this.getData()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        }
    },
    mounted() {
        this.errorMessage = 'Find Your Data'
    }
}
</script>
<style scoped>
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
@media screen and (min-width: 1253px) and (max-width: 1358px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1168px) and (max-width: 1252px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1097px) and (max-width: 1167px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1036px) and (max-width: 1096px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 992px) and (max-width: 1035px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1359px){
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
.btn-search {
    border-radius: 4px;
    float: left;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    float: left;
    width: 100%;
    margin-left: 4px;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(360deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(0deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 24px;
    padding-right: 24px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 12px;
    padding-right: 24px;
    padding-left: 24px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}
</style>